module.exports = __webpack_public_path__ + "static/media/calender.b8bdb3c7.svg";